import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, AppDispatch } from '../../redux';
import { fetchUtilizationAnalytics } from '../../redux/analytics/analyticSlice';

export const useFetchUtilizationAnalytics = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { clinicianUtil, isLoading, error } = useSelector((state: RootState) => state.analytic);

    const fetchAnalytics = useCallback((practiceId: string, date?: string, useLastWeek: boolean = false) => {
        const fetchDate = date || new Date().toISOString().split('T')[0];
        return dispatch(fetchUtilizationAnalytics({ 
            practiceId, 
            date: fetchDate, 
            useLastWeek 
        }));
    }, [dispatch]);

    return {
        clinicianUtil,
        isLoading,
        error,
        fetchAnalytics
    };
};
